<template>
    <template-base
        title      = "Vorlage"
        :items     = "templates"
        :variables = "variables"
        :create-allowed = "true"
        :settings-admin = "isSettingsAdmin"
        @save      = "onSave"
        @create    = "onCreate"
        @remove    = "onRemove"
        ref        = "base"
    >
        <template v-slot:ident="data" >
            <v-row class="no-frame mt-0">
                <v-col class="no-frame pr-2 col-9">
                    <f-read-only-field
                        v-if   = "data.item.standard"
                        label  = "Name"
                        :value = "data.item.name"
                        style  = "margin-top: 5px"
                    />
                    <v-text-field
                        v-if="!data.item.standard"
                        label          = "Name"
                        v-model        = "data.item.name"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        :readonly      = "!isSettingsAdmin"
                    />
                </v-col>
                <v-col class="no-frame pl-2">
                    <v-select
                        v-if="signatures"
                        :items="signatures"
                        item-value="id"
                        item-text="name"
                        label="Signatur"
                        return-object
                        v-model="data.item.signature"
                        :readonly      = "!isSettingsAdmin"
                    />
                </v-col>
            </v-row>
            <v-row class="no-frame">
                <v-col class="no-frame">
                    <v-text-field
                        label="Betreff"
                        v-model        = "data.item.subject"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        :readonly      = "!isSettingsAdmin"
                    />
                </v-col>
            </v-row>
        </template>
    </template-base>
</template>

<script>

import Core         from "@/modules/core/service/Core";
import TemplateBase from "@/modules/msd/templates/components/TemplateBase";
import Template     from "@/modules/msd/templates/service/Template";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField";

export default {
    name: "TemplateMails",

    components: {
        FReadOnlyField,
        TemplateBase
    },

    props: {
        customer: {
            required: false,
            type    : Number,
            default : function () {
                return 0;
            }
        }
    },

    data: () => ({
        templates : [],
        signatures: [],
        variables : []
    }),

    computed: {
        isSettingsAdmin () {
            return Core.security.isSettingsAdmin() || this.customer !== 0;
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.load();
        });
    },

    methods: {
        load () {
            Template.loadTemplates(this.customer, false,(data) => {
                this.templates = data;
                Template.loadSignature(this.customer, (data) => {
                    this.signatures = data;
                    this.$refs.base.refresh();
                });
            });

            Template.loadVariable( (data) => {
                this.variables = data;
            });
        },

        onCreate () {
            Template.create(this.customer).then(() => {
                this.load();
                Core.message.hint(this, "Vorlage wurde angelegt!")
            });
        },

        onSave (template) {
            Template.saveTemplate(template, () => {
                Core.message.hint(this, "Vorlage wurde gespeichert!")
            })
        },

        onRemove (template) {
            console.log("on revoce", template)
            Template.remove(template).then(() => {
               Core.message.alert.save(this);
            });
        }
    }
}

</script>

<style scoped>

</style>